export const logError = async (error, userId, activity, params, other) => {
  console.log("Logging error:", error);
  try {
    // Extract error details
    const errorCode = error.status || error.code || 500; // Default to 500
    const errorBody = error.message || JSON.stringify(error);

    // Try to get JWT in a safer way
    let jwt = null;
    try {
      // Check if we're in browser environment
      if (typeof window !== "undefined") {
        // Get the user object from localStorage
        const userJSON = localStorage.getItem("user");
        if (userJSON) {
          try {
            const userObj = JSON.parse(userJSON);
            jwt = userObj.jwt;

            // If userId wasn't provided, use the one from localStorage
            if (!userId && userObj.id) {
              userId = String(userObj.id); // Convert to string
            }
          } catch (e) {
            console.log("Failed to parse user JSON:", e);
          }
        }

        // If we still don't have a JWT, try other common keys
        if (!jwt) {
          jwt = localStorage.getItem("jwt") || localStorage.getItem("token");
        }
      }
    } catch (storageError) {
      console.log("Error accessing localStorage:", storageError);
    }

    // Create headers with or without authorization
    const headers = {
      "Content-Type": "application/json",
    };

    // Only add Authorization if we have a JWT
    if (jwt) {
      headers.Authorization = `Bearer ${jwt}`;
    }

    // exclude network errors from being logged to Strapi
    if (
      errorCode === "NETWORK_ERROR" ||
      errorCode === "PROMISE_REJECTION" ||
      errorCode === "ECONNABORTED" || // Axios timeout
      errorCode === "ENOTFOUND" || // DNS lookup failed
      errorCode === "ECONNREFUSED" || // Connection refused
      errorCode === 0 // Generic network error
    ) {
      console.log("Network error detected, skipping Strapi logging.");
      return;
    }

    // Send data to Strapi
    const response = await fetch(
      `${process.env.GATSBY_STRAPI_API_URL}/api/error-logs`,
      {
        method: "POST",
        headers,
        body: JSON.stringify({
          data: {
            code: errorCode ? String(errorCode) : "-", // Ensure it's a string
            body: errorBody,
            userId: userId ? String(userId) : "anonymous", // Ensure it's a string
            activity: activity || "unknown",
            params: params ? JSON.stringify(params) : null,
            other: other || null,
          },
        }),
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      console.error("Error logging failed:", errorData);
      throw new Error(`Failed to log error in Strapi: ${response.status}`);
    }

    console.log("Error logged successfully.");
  } catch (logError) {
    console.error("Failed to log error:", logError);
  }
};
